import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from 'vue';
import { SnowplowLoginContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { useTitleDetailsStore, useTrackingStore, useUserStore, useAppStore } from '@/helpers/composables/useStores';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { captureMessageForSentry } from '@/helpers/sentry-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdBlockerBait',
  setup(__props) {

const { jwLoginId } = useUserStore();
const { titleContext } = useTitleDetailsStore();
const { setSessionEnvironmentByKey } = useTrackingStore();
const { setIsUsingAdBlocker } = useAppStore();

const bait = ref<HTMLElement | null>(null);

const blocked = ref(false);
const lastTrackedValue = ref<boolean | null>(null);
let adblockerTrackCount = 0;

async function handleAdblockerTracking() {
	if (!blocked.value) {
		await new Promise(resolve => setTimeout(resolve, 100));
	}

	// already tracked an adblocker
	if (lastTrackedValue.value) return;

	const contexts = [];
	if (titleContext.value) {
		const { titleId, objectType, seasonNumber, episodeNumber, contentType } = titleContext.value;
		contexts.push(new SnowplowTitleContextGraphql(titleId, objectType, seasonNumber, episodeNumber, contentType));
	}

	if (jwLoginId.value) contexts.push(new SnowplowLoginContext(jwLoginId.value));

	setIsUsingAdBlocker(!!blocked.value);

	TrackingHelper.trackEvent(
		'adblocker',
		{
			action: 'detected',
			value: blocked.value ? 1 : 0,
			nonInteraction: true,
		},
		contexts
	);
	setSessionEnvironmentByKey({ key: 'hasAdBlocker', value: blocked.value });
	// hasAdBlocker is the last sessionEnvironment key to be set, so we can now set sessionReady to true
	setSessionEnvironmentByKey({ key: 'sessionReady', value: true });

	lastTrackedValue.value = blocked.value;

	if (++adblockerTrackCount > 1) {
		captureMessageForSentry(
			'[handleAdblockerTracking triggered more than once]',
			{ where: 'Component: AdBlockerBait', message: 'adblocker tracking count :' + adblockerTrackCount },
			'info'
		);
	}
}

//Track blocked status changes, since @error() might take time to fire
watch(blocked, blockedUpdate => {
	if (blockedUpdate === true && !lastTrackedValue.value) handleAdblockerTracking();
});

onMounted(() => {
	blocked.value = blocked.value || bait.value === null || window.getComputedStyle(bait.value).display === 'none';
	handleAdblockerTracking();
});

return { __sfc: true,jwLoginId, titleContext, setSessionEnvironmentByKey, setIsUsingAdBlocker, bait, blocked, lastTrackedValue, adblockerTrackCount, handleAdblockerTracking }
}

})